import React, { useMemo } from 'react';
import { Checkbox, Form } from 'antd';
import { WrappedFieldProps } from 'redux-form';
import { FormItemProps } from 'antd/lib/form';
import { CheckboxProps } from 'antd/lib/checkbox';

export const CheckboxField = React.memo<
  WrappedFieldProps & { item: FormItemProps; field: CheckboxProps }
>(({ input, item, field, meta: { touched, error, warning } }) => {
  const errorText = useMemo(() => touched && error, [touched, error]);
  const warningText = useMemo(() => touched && warning, [touched, warning]);
  const validateStatus = useMemo(() => {
    if (errorText) {
      return 'error';
    } else if (warningText) {
      return 'warning';
    }
  }, [errorText, warningText]);

  return (
    <Form.Item
      validateStatus={validateStatus}
      help={errorText || warningText}
      {...item}
    >
      <Checkbox {...input} {...field} />
    </Form.Item>
  );
});
